import { getFacetFiltersForPatientMatching } from '@caresend/utils';
import '../../../../../../database/algoliaConfig/indices.js';
import { searchUsers } from '../../../../../../database/algoliaConfig/methods.js';
import '@caresend/types';
import 'firebase/auth';
import { getAlgoliaAPIKeyForSearchPatientsRequest } from '../../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../../database/firebaseConfig/init.js';
import '../../../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../../ui/Icon.vue.js';
import '../../../../../../functions/configuration/icons.js';
import 'mobile-device-detect';
import '../../../../../../functions/tracking/index.js';
import '../../../../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';

const searchPatient = async (info) => {
    var _a;
    const { patientFirstName, patientLastName, patientDob, patientGender, userInfo, props, } = info;
    let user = null;
    let searchResult = null;
    const facetFilters = getFacetFiltersForPatientMatching({
        firstName: patientFirstName,
        lastName: patientLastName,
        dateOfBirth: patientDob,
        gender: patientGender,
        email: userInfo.email,
        phone: userInfo.phone,
    }, props.entityType);
    const securedApiKeyResponse = await getAlgoliaAPIKeyForSearchPatientsRequest();
    const users = await searchUsers(securedApiKeyResponse.key, '', { facetFilters });
    if (users.length !== 0) {
        user = (_a = users.slice(0, 1).shift()) !== null && _a !== void 0 ? _a : null;
        searchResult = user;
    }
    return searchResult;
};

export { searchPatient };
